export default {
  name: 'LightGrayInformationBlock',
  props: {
    title: {
      type: String,
      default: undefined
    }
  }
};